import { memo } from 'react';
import { Box, Checkbox, FormControlLabel } from '@mui/material';

interface IGuideAgreementProps {
  agreement: boolean;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}
function GuideAgreement({ agreement, handleChange }: IGuideAgreementProps): JSX.Element {
  return (
    <Box sx={{ mt: { xs: '10px', sm: '20px' } }}>
      <FormControlLabel
        sx={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          '& .MuiFormControlLabel-label': {
            typography: 's24w800',
            fontSize: { xs: '1.2rem', sm: '2rem' },
          },
        }}
        control={<Checkbox checked={agreement} onChange={handleChange} name="agreement" />}
        label="확인했습니다. 진단평가 응시를 시작하겠습니다."
      />
    </Box>
  );
}

export default memo(GuideAgreement);
